import { Breadcrumbs as MUIBreadcrumbs, Box } from "@mui/material";
import Link from "next/link";
import { stripHTMLTags } from "@/src/utils/strip-html-tags";
import {
  FONT_UI,
  SHEET_GUTTER,
} from "@/src/components/common/broadsheet/tokens";

const crumbSx = {
  fontFamily: FONT_UI,
  fontSize: "0.6875rem",
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "uppercase" as const,
  whiteSpace: "nowrap" as const,
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: { xs: "9rem", md: "22rem" },
  display: "block",
  textDecoration: "none",
  paddingBlock: "0.5rem",
};

export default function Breadcrumbs({
  breadcrumbs,
  journal,
}: {
  breadcrumbs: any[];
  journal: any;
}) {
  return (
    <MUIBreadcrumbs
      separator="/"
      aria-label="Breadcrumb"
      sx={{
        px: SHEET_GUTTER,
        color: "custom.subtitleText",
        minWidth: 0,
        "& .MuiBreadcrumbs-ol": {
          flexWrap: "nowrap",
          minWidth: 0,
        },
        "& .MuiBreadcrumbs-ol > li": {
          display: { xs: "none", md: "block" },
          flex: "none",
          minWidth: 0,
        },
        "& .MuiBreadcrumbs-ol > li:nth-last-of-type(-n+3)": {
          display: "block",
        },
        "& .MuiBreadcrumbs-li:last-of-type": { flex: 1 },
        "& .MuiBreadcrumbs-separator": {
          mx: 0.375,
          fontFamily: FONT_UI,
          fontSize: "0.6875rem",
          color: "custom.inkMuted",
        },
      }}
    >
      <Box
        component={Link}
        href="/"
        sx={{
          ...crumbSx,
          color: "custom.link",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        {(journal.is_main_site && journal.title) || "Home"}
      </Box>
      {breadcrumbs.map((value, index) => {
        const href = value.link;
        const isLast = index === breadcrumbs.length - 1;

        return !href || href === "#" || isLast ? (
          <Box
            component="span"
            key={`${value.name}-${index}`}
            aria-current={isLast ? "page" : undefined}
            sx={{
              ...crumbSx,
              color: "custom.ink",
              maxWidth: isLast ? "none" : { xs: "9rem", md: "22rem" },
            }}
          >
            {stripHTMLTags(value.name)}
          </Box>
        ) : (
          <Box
            component={Link}
            href={href}
            key={`${value.name}-${index}`}
            sx={{
              ...crumbSx,
              color: "custom.link",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            {stripHTMLTags(value.name)}
          </Box>
        );
      })}
    </MUIBreadcrumbs>
  );
}
